import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { AuthCard, GoogleAuthSection, AUTH_INPUT_CLS } from "../components/AuthCard";

export default function Signup() {
  const { signup, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }
    setBusy(true);
    try {
      await signup(name, email, password);
      toast.success("Welcome to the House of Capra Falconeri.");
      navigate("/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not create account.");
      setBusy(false);
    }
  };

  return (
    <AuthCard title="Join the Maison" subtitle="Private previews. First access. Order history." testId="signup-page">
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="signup-name-input" required placeholder="Full name" value={name} onChange={(e) => setName(e.target.value)} className={AUTH_INPUT_CLS} />
        <input data-testid="signup-email-input" required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={AUTH_INPUT_CLS} />
        <input data-testid="signup-password-input" required type="password" placeholder="Password (min. 6 characters)" value={password} onChange={(e) => setPassword(e.target.value)} className={AUTH_INPUT_CLS} />
        <button
          data-testid="signup-submit-button"
          disabled={busy}
          className="w-full py-4 bg-capra-bronze text-capra-night text-[11px] uppercase tracking-[0.25em] font-semibold hover:bg-capra-amber transition-colors disabled:opacity-60"
        >
          {busy ? "Creating…" : "Create Account"}
        </button>
      </form>
      <GoogleAuthSection onGoogle={loginWithGoogle} testId="google-signup-button" />
      <p className="text-center text-xs text-capra-muted mt-8">
        Already a member?{" "}
        <Link to="/login" data-testid="go-to-login-link" className="text-capra-bronze hover:text-capra-amber transition-colors">
          Sign in
        </Link>
      </p>
    </AuthCard>
  );
}
